// @flow
import update from 'immutability-helper';
import type {ReduxActionType} from "../../flow/ReduxActionType";

const INITIAL_STATE = {
    translations: [],
    pagination: {
        page: 0,
        limit: 20,
        total: 0
    },
    filters: {
        languages: [],
        original: '',
        translation: '',
        // '' = All, otherwise 'manual' | 'ai' | 'base' (see handoff-dashboard.md §6)
        state: '',
        sortDirection: 'desc',
        exactOri: false,
        exactTrans: false
    },
    loading: true,
};

type State = { type?: string };

const Translations = (state: State = INITIAL_STATE, action: ReduxActionType) => {
    switch (action.type) {
        case 'TRANSLATIONS_LOAD':
            return {...state, loading: true};

        case 'TRANSLATIONS_LOADED':
            return {...state, loading: false, translations: action.payload.translations, pagination: action.payload.pagination};

        case 'TRANSLATIONS_SET_QUERY':
            return {
                ...state,
                filters: {...state.filters, ...action.payload.filters},
                pagination: {...state.pagination, page: action.payload.pagination.page, limit: action.payload.pagination.limit},
            };

        case 'TRANSLATIONS_CHANGE_INPUT': {
            const result = /(.*)\.(.*)?/.exec(action.payload.name);
            const path = result ? [result[1], result[2]] : ['filters', action.payload.name];

            const changed = JSON.stringify(state[path[0]][path[1]]) !== JSON.stringify(action.payload.value);
            const new_state = update(state, {[path[0]]: {[path[1]]: {$set: action.payload.value}}});

            // Another filter or page size means another list: its page 1 is the one to show.
            // Only the page itself, or a value that did not change, keeps the current page.
            if (changed && action.payload.name !== 'pagination.page') {
                return update(new_state, {pagination: {page: {$set: 0}}});
            }

            return new_state;
        }

        default:
            return {...state};
    }
};

export default Translations;
